import i18n, { type Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
    DEFAULT_LANGUAGE,
    getInitialLanguage,
    LANGUAGE_STORAGE_KEY,
    SUPPORTED_LANGUAGES,
} from './config';

type RequireContext = {
    keys: () => string[];
    <T = unknown>(id: string): T;
};

type WebpackRequire = NodeRequire & {
    context: (directory: string, useSubdirectories: boolean, pattern: RegExp) => RequireContext;
};

const localeFiles = (require as WebpackRequire).context('./locales', true, /\.json$/);

const resources = localeFiles.keys().reduce<Resource>((result: Resource, path: string) => {
    const match = path.match(/^\.\/([^/]+)\/([^/]+)\.json$/);
    if (!match) return result;

    const [, language, namespace] = match;
    result[language] ||= {};
    result[language][namespace] = localeFiles(path);
    return result;
}, {});

const initialLanguage = getInitialLanguage();

void i18n.use(initReactI18next).init({
    resources,
    lng: initialLanguage,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    defaultNS: 'common',
    fallbackNS: 'common',
    interpolation: {
        escapeValue: false,
    },
    returnEmptyString: false,
});

function syncLanguage(language: string) {
    document.documentElement.lang = language;
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
}

syncLanguage(initialLanguage);
i18n.on('languageChanged', syncLanguage);

export default i18n;
